import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown, faCirclePlay, faChevronUp, faExchange, faSmileBeam, faImage, faEdit, faLayerPlus, faBoxOpen, faChevronsLeft,
  faChevronsRight, faCalendarAlt, faClock, faCommentAltDots, faFilter, faListAlt, faUser, faChevronLeft } from '@fortawesome/pro-light-svg-icons';

library.add(faChevronDown, faCirclePlay, faChevronUp, faExchange, faSmileBeam, faImage, faEdit, faLayerPlus, faBoxOpen, faChevronsLeft,
  faChevronsRight, faCalendarAlt, faClock, faCommentAltDots, faFilter, faListAlt, faUser, faChevronLeft);
